import { DepositHistory } from "@/modules/deposit/components";
import { PageHeader } from "@/shared/components";

export const DepositHistoryPage = () => {
  return (
    <div className="full-width page-container">
      <PageHeader/>
      <DepositHistory/>
    </div>
  );
};
